import {CHANGE_PAGE_TABLE, FILTER_CHANGE, FILTERS_RESET, TAG_INFRASTRUCTURE_RESERVATIONS} from 'modules/ui';

import {isMobile} from 'util/utils';
import {invalidateReservations} from 'modules/store/reservations';
import {invalidateAwsAccounts} from 'modules/store/awsAccounts';
import {invalidateAwsInstanceTypes} from 'modules/store/awsInstanceTypes';
import {invalidateAwsProducts} from 'modules/store/awsProducts';
import {invalidateAwsRegions} from 'modules/store/awsRegions';

export const invalidateAwsReservations = () => dispatch => {
    dispatch(invalidateReservations());
    dispatch(invalidateAwsAccounts());
    dispatch(invalidateAwsInstanceTypes());
    dispatch(invalidateAwsProducts());
    dispatch(invalidateAwsRegions());
};


const CHANGE_SELECTED_AWS_RESERVATION = 'CHANGE_SELECTED_AWS_RESERVATION';
const CLEAR_SELECTED_AWS_RESERVATION = 'CLEAR_SELECTED_AWS_RESERVATION';

export const changeSelectedAWSReservations = selected => ({
    type: CHANGE_SELECTED_AWS_RESERVATION,
    selected
});

export const clearSelectedAWSReservations = () => ({
    type: CLEAR_SELECTED_AWS_RESERVATION
});


const _getInitialState = () => ({
    selected: null
});

const _getSelectedReservation = (state, selected) => {
    const currentSelected = state.selected;

    if (currentSelected) {
        if (currentSelected.reservationId === selected.reservationId) {
            return null;
        }
    }

    return selected;
};


export const reducer = (state = _getInitialState(), action = {}) => {
    switch (action.type) {
    case CHANGE_SELECTED_AWS_RESERVATION:

        return {
            selected: _getSelectedReservation(state, action.selected)
        };
    case CLEAR_SELECTED_AWS_RESERVATION:


        return {
            selected: null
        };
    case CHANGE_PAGE_TABLE:
    case FILTER_CHANGE:
    case FILTERS_RESET:
        if (action.section === TAG_INFRASTRUCTURE_RESERVATIONS) {

            if (action.type !== CHANGE_PAGE_TABLE ||
                !isMobile()) {
                return {
                    selected: null
                };
            }
        }
        break;
    default:
        return state;
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/modules/awsReservations.js